import '../css/app.css';
import { createApp, h } from 'vue';
import { createInertiaApp, router } from '@inertiajs/vue3';
import { createPinia } from 'pinia';
import { useLoader } from './Stores/useLoader';

const pinia = createPinia();

createInertiaApp({
    progress: false,
    resolve: name => {
        const pages = import.meta.glob('./Pages/**/*.vue', { eager: true });
        return pages[`./Pages/${name}.vue`];
    },
    async setup({ el, App, props, plugin }) {
        const app = createApp({ render: () => h(App, props) });
        app.use(plugin);
        app.use(pinia);

        const loader = useLoader();
        let isLoginRedirect = false;

        router.on('before', (event) => {
            const url = new URL(event.detail.visit.url, window.location.origin);
            const method = event.detail.visit.method?.toLowerCase() || 'get';
            const preserveState = event.detail.visit.preserveState;

            if (method === 'post' && url.pathname === '/login') {
                isLoginRedirect = true;
            }

            const isSoftNav =
                preserveState &&
                method === 'get' &&
                (
                    url.searchParams.has('page') ||
                    url.searchParams.has('search') ||
                    url.searchParams.has('filter')
                );

            if (isSoftNav) {
                loader.startPagination();
            } else if (method === 'get') {
                loader.start();
            }
        });

        router.on('finish', () => {
            const delay = isLoginRedirect ? 800 : 150;
            setTimeout(() => {
                if (loader.isPaginationLoading) loader.finishPagination();
                if (loader.isLoading) loader.finish();
                isLoginRedirect = false;
            }, delay);
        });

        router.on('error', () => {
            isLoginRedirect = false;
            loader.finishPagination();
            loader.finish();
        });

        app.mount(el);
    },
});